import React from 'react';
import '../styles/Sidebar.css';

const Sidebar = () => {
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    window.location.reload();
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>Dashboard</h2>
      </div>
      <nav className="sidebar-nav">
        <a href="#/" className="nav-item">
          <span>🏠</span> Home
        </a>
        <a href="#/dashboard" className="nav-item">
          <span>📊</span> Dashboard
        </a>
        <a href="#/users" className="nav-item">
          <span>👥</span> Users
        </a>
        <a href="#/settings" className="nav-item">
          <span>⚙️</span> Settings
        </a>
      </nav>
      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-btn">
          <span>🚪</span> Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;

